/* eslint-disable */
export default function sideNav() {
    const sideNavItems = jQuery('.side-nav__item');

    function isDesktop() {
        return window.innerWidth > 767;
    }

    function tabClick() {
        const item = jQuery(this);

        if (isDesktop()) {
            if (!item.hasClass('is-active')) {
                item
                    .siblings('.is-active')
                    .removeClass('is-active')
                    .children('.side-nav__content').fadeOut(0);

                item.addClass('is-active').children('.side-nav__content').fadeIn(350);
            }
            setHeight();
        }
        else {
            nodeClick(item);
        }
    }

    function moveSlide() {
        const list = jQuery('.side-nav__list');
        const activeItems = list.find('.is-active');
        const activeHeight = activeItems.length ? activeItems[0].offsetHeight : 100;
        const slide = list.find('.side-nav__tab-slide');
        let topPos = 0;

        sideNavItems.each(function(index) {
            if (jQuery(sideNavItems[index]).hasClass('is-active')) {
                return false;
            }
            topPos += sideNavItems[index].offsetHeight;
        });

        slide.css({
            top: topPos,
            height: activeHeight
        });
    }

    function setHeight() {
        const node = jQuery('.side-nav__list');

        if (isDesktop()) {
            const height = jQuery('.side-nav__item.is-active .side-nav__content').height();
            const listHeight = node.height();

            node.css({
                height: (height > listHeight) ? height : listHeight + 'px'
            });
            // move slide line
            moveSlide();
        }
        else {
            node.css({
                height: 'auto'
            });
        }
    }

    function setLinks() {
        const links = jQuery('.side-nav__list a');
        if (isDesktop()) {
            links.removeClass('one-line-link').addClass('link-blue-square')
        }
        else {
            links.removeClass('link-blue-square').addClass('one-line-link')
        }
    }

    function nodeClick(item) {
        if (item.hasClass('is-active')) {
            item.find('.side-nav__content').css('display', 'block').slideUp(350);
            item.removeClass('is-active');
        } else {
            const activeItems = item.siblings().filter('.is-active');
            activeItems.find('.side-nav__content').css('display', 'block').slideUp(350);
            activeItems.removeClass('is-active');

            item.find('.side-nav__content').slideDown(350);
            item.addClass('is-active');
        }
    }

    sideNavItems.on('click', tabClick);
    setHeight();
    setLinks();
}
